import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Label } from "@/DesignSystem/Molecules/ToolBox/Label";
import { DateSelector } from "../Inputs/DateSelector";
import { TimeSelector } from "../Inputs/TimeSelector";

import styles from "./AdditionalInformationForm.module.scss";

interface IResultsDateSentFormProps {
    resultSentDateTime: Date;
    onChange: (resultSentDateTime: Date) => void;
}

function ResultsDateSentForm(props: Readonly<IResultsDateSentFormProps>): JSX.Element {
    const { getText } = useTranslation();
    const handleDateTimeChange = (date: Date, type: "date" | "time"): void => {
        let nextDateTime = new Date(props.resultSentDateTime);

        if (type === "date") {
            nextDateTime.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
        }
        else {
            nextDateTime.setHours(date.getHours(), date.getMinutes(), date.getSeconds());
        }

        props.onChange(nextDateTime);
    };

    return (
        <>
            <div
                className={styles.date}
            >
                <Label
                    label={getText("DateSentLabel")}
                    htmlFor="result-entry-date"
                />
                <DateSelector
                    id="result-sent-date"
                    dataCy="result-sent-date"
                    date={props.resultSentDateTime}
                    onChangeCallback={date => handleDateTimeChange(date, "date")}
                    dateFormat="yyyy-MM-dd"
                    placeholder="YYYY-MM-DD"
                />

            </div>
            <div className={styles.time}>
                <Label
                    label={getText("TimeSentLabel")}
                    htmlFor="result-sent-time"
                />
                <TimeSelector
                    id="result-sent-time"
                    dataCy="result-sent-time"
                    date={props.resultSentDateTime}
                    onChangeCallback={date => handleDateTimeChange(date, "time")}
                    dateFormat="HH:mm:ss"
                    placeholder="hh:mm:ss"
                />
            </div>
        </>
    );
}

export { ResultsDateSentForm };
